exports = module.exports = require("../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.c-grid-button-column[data-v-862e6e6e] {\n  display: none;\n}\n", ""]);

// exports
